<template>
    <div>
        <h2 class="md:text-xl font-black">{{ $page.props.productVariant?.title || product.title }}</h2>

        <div v-if="reviews" class="flex items-center mt-3">
            <Rating :rating="product.rating"/>

            <Message class="w-4 mr-1.5" :class="{'ml-1.5': product.rating}"/>
            <button
              class="text-sm hover:text-indigo-500 mt-0.5"
              @click="showReviews"
            >{{ reviews.meta.total || 'Залишити відгук' }}
            </button>
        </div>
    </div>
</template>

<script>
import {Link} from "@inertiajs/vue3";
import Message from '@/Components/Svg/Message.vue';
import Rating from '@/Components/Products/Rating.vue';

export default {
    components: { Rating, Message, Link},
    props: {
        product: Object,
        reviews: Object,
    },
    methods: {
        showReviews() {
            window.scrollTo({
                top: document.getElementById('reviews').offsetTop - 100,
                behavior: "smooth",
            })
        },
    }
}
</script>
